import data from './nimLang_ara.json';
const LocaleConfig = {
    ...data,
    "AllRight": "[حسنًا]",
    "Ambulance": "[سيارة إسعاف]",
    "Angle": "[ملاك]",
    "Angry": "[غاضب]",
    "Applause": "[تصفيق]",
    "Awkward": "[محرج]",
    "Beckoning": "[نبض القلب]",
    "Bomb": "[قنبلة]",
    "Broken": "[محطم القلب]",
    "Bye": "[وداعا وداعا]",
    "Cloud": "[سحابة الشقلبة]",
    "Cool": "[رائع]",
    "Cry": "[بكاء]",
    "Cute": "[لطيف]",
    "Despise": "[احتقار]",
    "Disdain": "[ازدراء]",
    "Ecstasy": "[نشوة]",
    "First": "[أولاً]",
    "Fist": "[قبضة]",
    "Fretting": "[منزعج]",
    "Frown": "[عبوس]",
    "Funny": "[يضحك ويبكي]",
    "Ghost": "[عفريت]",
    "GiveMeFive": "[نخل]",
    "GoodJob": "[قوي]",
    "Grimace": "[كشر]",
    "Halo": "[النجوم في عيني]",
    "Happy": "[سعيد]",
    "Hi": "[موجة]",
    "Hit": "[ضربك]",
    "Hold": "[حامل]",
    "Joy": "[مرح]",
    "Kiss": "[نسبي]",
    "Knife": "[مقص]",
    "Laugh": "[يضحك بصوت عال]",
    "Low": "[مستوى منخفض]",
    "Mad": "[غضب]",
    "Mask": "[قناع وجه]",
    "Mischievous": "[ابتسامة شريرة]",
    "Monkey": "[قرد]",
    "Nice": "[مدح]",
    "No": "[لا أريد]",
    "NoListen": "[لا يستمع]",
    "NoLook": "[لا تشاهد]",
    "NoWords": "[لا ينبغي أن يقال]",
    "Ok": "[نعم]",
    "Pig": "[رأس الخنزير]",
    "Please": "[أميتابها]",
    "Poop": "[يتبرّز]",
    "Rocket": "[صاروخ]",
    "Sexy": "[لون]",
    "Shame": "[خجول]",
    "Sleep": "[ينام]",
    "Sleeping": "[ينام]",
    "Snicker": "[يضحك]",
    "Spit": "[يخرج لسانه]",
    "Squint": "[التحديق]",
    "Surprise": "[مفاجأة]",
    "Sweat": "[يعرق]",
    "Tears": "[دموع]",
    "Terrorist": "[يخاف]",
    "Think": "[يفكر]",
    "Thrill": "[مذعور]",
    "Tired": "[نجم]",
    "Uncomfortable": "[غير مريح]",
    "Unhappy": "[تعيس]",
    "acceptFailedText": "فشل الموافقة على الطلب",
    "acceptResultText": "متفق",
    "acceptText": "يوافق",
    "acceptedText": "متفق",
    "accountNotMatchText": "لم يتم العثور على مثل هذا الحساب",
    "accountPlaceholder": "الرجاء إدخال رقم حسابك",
    "accountText": "حساب",
    "addButtonText": "اضف إليه",
    "addChatMemberText": "إضافة أعضاء الدردشة",
    "addFailedText": "إضافة فاشلة",
    "addFriendFailedText": "فشل في إضافة صديق",
    "addFriendMode": "وضع إضافة صديق",
    "addFriendSuccessText": "تمت إضافة صديق بنجاح",
    "addFriendText": "أضف أصدقاء",
    "addMessageTop": "تم تثبيت رسالة",
    "addStickTopText": "رسالة لاصقة",
    "addSuccessText": "تمت الإضافة بنجاح",
    "addTeamMemberConfirmText": "الرجاء تحديد عضو المجموعة الذي تريد إضافته",
    "addTeamMemberFailedText": "فشل في إضافة العضو",
    "addTeamMemberSuccessText": "تمت إضافة العضو بنجاح",
    "addTeamMemberText": "إضافة أعضاء",
    "addTeamMemberVerifyText": "في انتظار التحقق",
    "addressText": "جهات الاتصال",
    "aiAntiSpamText": "طلب الذكاء الاصطناعي يصطدم بمكافحة البريد العشوائي",
    "aiBlockFailedText": "لا يجوز إدراج الأشخاص الرقميين في القائمة السوداء",
    "aiConversationSelectFailed": "فشل تحديد جلسة الذكاء الاصطناعي",
    "aiErrorText": "الخادم مشغول، يرجى المحاولة مرة أخرى لاحقًا",
    "aiFriendNotExists": "الصديق غير موجود",
    "aiFunctionDisabled": "لم يتم تفعيل وظيفة رسالة الذكاء الاصطناعي",
    "aiListTitle": "رجلي الرقمي",
    "aiMemberBanned": "المستخدم معطل",
    "aiMemberChatBanned": "تم حظر المستخدم",
    "aiMenuText": "رجلي الرقمي",
    "aiMessageHitAntiSpam": "رسالة مكافحة البريد العشوائي",
    "aiNormalTeamChatBanned": "حظر أعضاء المجموعة العاديين",
    "aiParameterError": "خطأ في المعلمة",
    "aiProxyFailedText": "استثناء طلب النموذج",
    "aiRateLimit": "التردد يتجاوز الحد",
    "aiSearchInputPlaceholder": "الرجاء إدخال المزيد من المعلومات",
    "aiSearchText": "البحث عن الكلمات باستخدام الذكاء الاصطناعي",
    "aiSearchingText": "البحث عن الكلمات بالذكاء الاصطناعي قيد التقدم...",
    "aiSendingText": "استجابة طلب النموذج الكبير",
    "aiStopFailedText": "فشل إيقاف الإخراج",
    "aiStreamCancelText": "تم إلغاء الطلب",
    "aiStreamText": "إخراج البث الرقمي",
    "aiTeamChatBanned": "تم حظر عضو المجموعة",
    "aiTeamMemberNotExists": "عضو المجموعة غير موجود",
    "aiTranslateEmptyText": "الرجاء إدخال المحتوى الذي تريد ترجمته",
    "aiTranslatePlaceholder": "ترجم إلى...",
    "aiTranslateText": "معالجة الذكاء الاصطناعي",
    "aiTranslatedText": "يستخدم",
    "aiTranslatingText": "معالجة الذكاء الاصطناعي...",
    "aiUserText": "الإنسان الرقمي",
    "aleadyInTeamText": "موجود بالفعل في المجموعة",
    "aliasText": "ملاحظة",
    "allReadText": "الكل قرأ",
    "allUnReadText": "جميع غير المقروءة",
    "amap": "أماب",
    "applyFriendFailedText": "فشل تطبيق إضافة صديق",
    "applyFriendSuccessText": "تطبيق لإضافة صديق بنجاح",
    "applyFriendText": "أضفك كصديق",
    "applyTeamSuccessText": "تم قبول طلب الانضمام للمجموعة بنجاح",
    "applyTeamText": "التقدم بطلب الانضمام للمجموعة",
    "audioMsgText": "رسالة صوتية",
    "bdmap": "خريطة بايدو",
    "beAddTeamManagersText": "تم تعيينه كمدير",
    "beMentioned": "[شخص ما @ لي]",
    "beRejectResultText": "تم رفض طلب الصداقة",
    "beRemoveTeamManagersText": "تمت إزالة المسؤول",
    "beRemoveTeamText": "تمت إزالته من المجموعة",
    "blackFailedText": "فشلت القائمة السوداء",
    "blackListDesc": "(لن تتلقى رسائل من أي من جهات الاتصال الموجودة في القائمة)",
    "blackListTitle": "القائمة السوداء",
    "blackMenuText": "القائمة السوداء",
    "blackSuccessText": "نجاح القائمة السوداء",
    "blackText": "حظر الأصدقاء",
    "callBusyText": "الطرف الآخر مشغول",
    "callCancelText": "تم الإلغاء",
    "callDurationText": "وقت التحدث",
    "callFailed": "فشلت المكالمة",
    "callMsgText": "رسالة تسجيل المكالمات",
    "callRejectedText": "مرفوض",
    "callTimeoutText": "انتهت المهلة",
    "cancelText": "يلغي",
    "cancelUploadFailedText": "فشل إلغاء التحميل",
    "chatButtonText": "اذهب للدردشة",
    "chatHistoryText": "سجل الدردشة",
    "closeAgreeModeText": "تم تعطيل شرط الموافقة على دعوات المجموعة",
    "closeApplyModeText": "التدقيق الجماعي المغلق",
    "closeText": "إنهاء",
    "collection": "يجمع",
    "collectionFailed": "فشلت عملية التجميع",
    "collectionSuccess": "تم جمعها بالفعل",
    "collectionText": "يجمع",
    "commentText": "رسالة",
    "confirmDeleteFriendText": "هل أنت متأكد أنك تريد حذف الصديق؟",
    "confirmDeleteText": "هل أنت متأكد أنك تريد الحذف؟",
    "confirmRemoveCollection": "تأكيد حذف المفضلة؟",
    "createButtonText": "يخلق",
    "createDiscussionText": "إنشاء مجموعة نقاش",
    "createTeamFailedText": "فشل في إنشاء المجموعة",
    "createTeamMemberLimitText": "الحد الأقصى لعدد الأشخاص في المجموعة",
    "createTeamSuccessText": "تم إنشاء المجموعة بنجاح",
    "createTeamText": "إنشاء مجموعة",
    "customMsgText": "رسالة مخصصة",
    "deleteFriendFailedText": "فشل في حذف الصديق",
    "deleteFriendSuccessText": "تم حذف الصديق بنجاح",
    "deleteFriendText": "حذف صديق",
    "deleteSessionText": "حذف جلسة",
    "deleteStickTopText": "إزالة التثبيت",
    "deleteText": "يمسح",
    "discussionAvatarText": "صورة رمزية لمجموعة المناقشة",
    "discussionDoNotDisturbText": "مجموعة المناقشة لا تزعج",
    "discussionIdText": "معرف مجموعة المناقشة",
    "discussionMemberText": "المتحدثون",
    "discussionText": "معلومات مجموعة المناقشة",
    "discussionTitle": "اسم مجموعة المناقشة",
    "dismissTeamConfirmText": "هل تؤكد حل المجموعة؟",
    "dismissTeamFailedText": "فشل حل المجموعة",
    "dismissTeamSuccessText": "تم حل المجموعة بنجاح",
    "dismissTeamText": "حل مجموعة",
    "editNickInTeamText": "تعديل لقبي في المجموعة",
    "emailErrorText": "صيغة البريد الإلكتروني غير صحيحة",
    "emailPlaceholder": "الرجاء إدخال عنوان بريدك الإلكتروني",
    "emailText": "بريد",
    "enText": "إنجليزي",
    "enableV2CloudConversationText": "هل سيتم فتح جلسة السحابة",
    "enterTeamText": "دخلت المجموعة",
    "expiredResultText": "منتهي الصلاحية",
    "fileMsgText": "رسالة الملف",
    "forwardFailedText": "فشل إعادة التوجيه",
    "forwardSuccessText": "تمت إعادة التوجيه بنجاح",
    "forwardText": "إلى الأمام",
    "friendListTitle": "أصدقائي",
    "friendMenuText": "أصدقائي",
    "friendText": "أصدقاء",
    "genderPlaceholder": "الرجاء تحديد الجنس",
    "genderText": "جنس",
    "geoMsgShortText": "موقع",
    "geoMsgText": "رسالة الموقع",
    "getApplyMsgFailedText": "فشل في الحصول على الرسالة",
    "getCollectionFailed": "فشل في الاستعلام عن قائمة المفضلة",
    "getHistoryMsgFailedText": "فشل في الحصول على الرسائل التاريخية",
    "getRelationFailedText": "فشل في الحصول على العلاقة",
    "huff": "[غاضب]",
    "ill": "[غير مريح]",
    "imgMsgText": "رسالة مصورة",
    "imgText": "صورة",
    "inCallText": "أنت الآن في مكالمة، يرجى إنهاء المكالمة قبل الاتصال مرة أخرى",
    "inviteTeamText": "أدعوك للانضمام",
    "inviteText": "يدعو",
    "joinTeamFailedText": "فشل الانضمام للمجموعة",
    "joinTeamSuccessText": "انضمت للمجموعة بنجاح",
    "joinTeamText": "انضم إلى مجموعة",
    "joinTeamWithVerifyText": "تم إرسال طلب الانضمام للمجموعة",
    "languageText": "لغة",
    "leaveDiscussionButtonText": "الخروج من مجموعة المناقشة",
    "leaveDiscussionConfirmText": "هل أنت متأكد من الخروج من مجموعة المناقشة هذه؟",
    "leaveDiscussionFailedText": "فشل الخروج من مجموعة المناقشة هذه",
    "leaveDiscussionSuccessText": "تم مغادرة مجموعة المناقشة هذه بنجاح",
    "leaveDiscussionText": "غادرت مجموعة المناقشة",
    "leaveDiscussionTitle": "الخروج من مجموعة المناقشة",
    "leaveTeamButtonText": "حذف وخروج",
    "leaveTeamConfirmText": "هل أنت متأكد من الخروج من هذه المجموعة؟",
    "leaveTeamFailedText": "فشل في مغادرة هذه المجموعة",
    "leaveTeamSuccessText": "تم مغادرة هذه المجموعة بنجاح",
    "leaveTeamText": "غادر المجموعة",
    "leaveTeamTitle": "مغادرة المجموعة",
    "logoutConfirmText": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    "logoutText": "تسجيل الخروج",
    "man": "ذكر",
    "maxSelectedText": "يمكنك فقط الاختيار",
    "memberNotExistsText": "المستخدم غير موجود",
    "msgListTitle": "مركز الرسائل",
    "msgMenuText": "مركز الرسائل",
    "msgRecallTimeErrorText": "لقد مضى الوقت ولا يمكن التراجع عنه",
    "muteAllTeamFailedText": "فشل في تمكين كتم الصوت لجميع الأعضاء",
    "muteAllTeamSuccessText": "تم تمكين وظيفة كتم الصوت بنجاح لجميع الأعضاء",
    "muteSessionText": "تشغيل عدم الإزعاج",
    "needBeInvitedText": "يجب الحصول على موافقة المدعو",
    "needMentionText": "هل تحتاج @message؟",
    "needVerifyText": "يتطلب التحقق",
    "networkDisconnectText": "تم فقدان اتصال الشبكة، يرجى التحقق من إعدادات الشبكة ومحاولة إعادة الاتصال",
    "newGroupOwnerText": "كن مالكًا جديدًا للمجموعة",
    "nickInTeamText": "لقبي في المجموعة",
    "nickPlaceholder": "الرجاء إدخال لقبك",
    "nickText": "كنية",
    "noMoreCollectionText": "الانزلاق إلى الأسفل ~",
    "noMoreText": "لا مزيد من الأخبار",
    "noPermission": "ليس لديك إذن للعمل",
    "noText": "لا",
    "notAnAi": "ليس حسابًا رقميًا",
    "notNeedBeInvitedText": "لا يلزم الحصول على موافقة من المدعو",
    "notNeedVerifyText": "لا يتطلب التحقق",
    "notSupportJoinText": "لا يمكن الانضمام لمجموعة المناقشة بشكل مباشر، يرجى التواصل مع المسؤول لإضافتك إلى المجموعة",
    "notSupportMessageText": "هذه الرسالة غير مدعومة حاليًا",
    "notiMsgText": "رسالة الإشعار",
    "offlineText": "(غير متصل)",
    "ok": "[نعم]",
    "okText": "بالتأكيد",
    "onDismissDiscussionText": "لقد تم حل مجموعة المناقشة",
    "onDismissTeamText": "لقد تم حل المجموعة",
    "onRemoveTeamText": "لقد تمت إزالتك من المجموعة",
    "onlineText": "(متصل)",
    "onlyTeamOwner": "أصحاب المجموعة فقط",
    "openAgreeModeText": "تتطلب الدعوة للانضمام إلى المجموعة الموافقة.",
    "openApplyModeText": "تم فتح التدقيق الجماعي",
    "openText": "يفتح",
    "oppositeSide": "الجانب الآخر",
    "p2pMsgVisibleModeText": "ما إذا كان سيتم عرض رسائل p2p المقروءة وغير المقروءة",
    "passFriendAskText": "لقد وافقت على طلبك، دعنا نبدأ الدردشة الآن~",
    "passResultText": "تم قبول طلب الصداقة",
    "personUnit": "الناس",
    "phonePlaceholder": "الرجاء إدخال رقم هاتفك",
    "phoneText": "الهاتف الخلوي",
    "pinAIText": "دبوس",
    "processedValidationMessageText": "تمت معالجة رسالة التحقق",
    "readText": "يقرأ",
    "recallMessageText": "سحبت رسالة",
    "recallReplyMessageText": "تم سحب هذه الرسالة أو حذفها",
    "recallText": "ينسحب",
    "receiveText": "لقد تلقيت رسالة جديدة",
    "recentConversationText": "الجلسات الأخيرة",
    "recentForwardText": "تم إعادة توجيهها مؤخرًا",
    "recentSessionText": "الزيارات الأخيرة",
    "reeditText": "إعادة التحرير",
    "regenAIMsgFailedText": "فشل التجديد",
    "rejectFailedText": "فشل رفض الطلب",
    "rejectResultText": "مرفوض",
    "rejectTeamFailedText": "فشل رفض طلب المجموعة",
    "rejectTeamInviteText": "تم رفض دعوة المجموعة",
    "rejectText": "يرفض",
    "rejectedTeamText": "تم رفض طلب المجموعة",
    "rejectedText": "لقد تم رفض الطلب",
    "removeBlackFailedText": "فشل إلغاء الحظر",
    "removeBlackSuccessText": "تم إلغاء الحظر بنجاح",
    "removeBlackText": "إلغاء الحظر",
    "removeCollectionFailed": "فشل في حذف المفضلة",
    "removeCollectionSuccess": "تم حذف المفضلة بنجاح",
    "removeMessageTop": "تمت إزالة الرسالة اللاصقة",
    "removeTeamMemberConfirmText": "هل أنت متأكد أنك تريد إزالة هذا العضو؟",
    "removeTeamMemberFailedText": "فشل في إزالة العضو",
    "removeTeamMemberSuccessText": "تم إزالة العضو بنجاح",
    "removeTeamMemberText": "إزالة العضو",
    "replyText": "رد",
    "robotMsgText": "رسالة الآلة",
    "saveFailedText": "فشل الحفظ",
    "saveSuccessText": "تم الحفظ بنجاح",
    "saveText": "يحفظ",
    "sdkVersionSelectionText": "اختيار إصدار SDK",
    "searchButtonText": "يجد",
    "searchDiscussionMemberPlaceholder": "البحث عن أعضاء المجموعة",
    "searchDiscussionTitle": "مجموعة المناقشة",
    "searchEmptyText": "لم تقم بإضافة أي أصدقاء أو مجموعات بعد",
    "searchFriendTitle": "أصدقاء",
    "searchInputPlaceholder": "يبحث",
    "searchNoResText": "لم يتم العثور على نتائج البحث",
    "searchTeamMemberPlaceholder": "البحث عن أعضاء المجموعة",
    "searchTeamPlaceholder": "الرجاء إدخال اسم المجموعة",
    "searchTeamTitle": "المجموعات",
    "searchText": "يبحث",
    "searchTipText": "أدخل البحث",
    "securityTipText": "يتم استخدامه فقط لتجربة وظائف منتجات Yunxin IM. من فضلك لا تصدق المعلومات المتعلقة بالمال مثل التحويلات المالية والأرباح. لا تتصل بأرقام غير مألوفة بسهولة حتى لا يتم خداعك.",
    "selectedText": "مُختار",
    "sendBlackFailedText": "لقد تم إدراجك في القائمة السوداء للطرف الآخر",
    "sendBtnText": "يرسل",
    "sendEmptyText": "لا يمكن إرسال رسالة فارغة",
    "sendMsgFailedText": "فشل إرسال الرسالة",
    "sendNotFriendFailedText": "علاقة غير صداقة حالية",
    "sendText": "إرسال رسالة",
    "sendToText": "أرسل إلى",
    "sendUsageText": "(اضغط على Enter لإرسال مباشرة، واضغط على Shift+Enter للتغليف)",
    "session": "حصة",
    "setText": "يثبت",
    "settingText": "يثبت",
    "signPlaceholder": "الرجاء إدخال توقيعك",
    "signText": "لافتة",
    "strangerNotiText": "هذا الشخص ليس صديقك في الوقت الحالي. يرجى توخي الحذر لحماية خصوصيتك.",
    "strangerText": "غريب",
    "teamAgreeModeExplainText": "بعد تشغيله، يحتاج الأعضاء إلى موافقة مالك المجموعة أو المسؤول للانضمام إلى المجموعة",
    "teamAgreeModeText": "مراجعة القبول الجماعي",
    "teamAll": "الجميع",
    "teamAtModeText": "من يستطيع @الجميع",
    "teamAvatarConfirmText": "لا يمكن أن يكون الصورة الرمزية للمجموعة فارغة",
    "teamAvatarText": "الصورة الرمزية للمجموعة",
    "teamDoNotDisturbText": "عدم الإزعاج الجماعي",
    "teamIdNotMatchText": "لم يتم العثور على رقم المجموعة هذا",
    "teamIdPlaceholder": "الرجاء إدخال معرف المجموعة",
    "teamIdText": "معرف المجموعة",
    "teamInfoText": "معلومات المجموعة",
    "teamInviteModeText": "من يمكنه دعوة أعضاء جدد؟",
    "teamJoinModeExplainText": "بعد الفتح، يمكنك إضافة أشخاص إلى المجموعة، ويجب على المدعو الموافقة.",
    "teamJoinModeFreeText": "الانضمام مجاني، ولا يتطلب التحقق",
    "teamJoinModeNeedVerifyText": "يجب عليك التقديم والانضمام بعد موافقة مالك المجموعة أو المسؤول عنها",
    "teamJoinModeText": "الدعوة للانضمام للمجموعة تتطلب الموافقة",
    "teamListTitle": "مجموعاتي",
    "teamManagerEditText": "إدارة الأفراد",
    "teamManagerEmptyText": "لا يوجد مسؤولو المجموعة",
    "teamManagerEnableText": "ما إذا كان سيتم تمكين وظيفة مسؤول المجموعة",
    "teamManagerLimitText": "من يمكنه تعديل المعلومات؟",
    "teamManagerText": "مسؤول المجموعة",
    "teamMemberLimitText": "وصل عدد أعضاء المجموعة إلى الحد الأقصى",
    "teamMemberNotExist": "لم تعد هذه الدردشة الجماعية موجودة",
    "teamMemberText": "أعضاء المجموعة",
    "teamMenuText": "مجموعاتي",
    "teamMsgVisibleModeText": "ما إذا كان سيتم عرض رسائل المجموعة كمقروءة أو غير مقروءة",
    "teamMutePlaceholder": "تم كتم صوت الدردشة الجماعية الحالية",
    "teamMuteText": "كتم صوت المجموعة",
    "teamNotExitsText": "المجموعة غير موجودة",
    "teamOwnerAndManagerText": "مالكي المجموعة والمسؤولين عنها",
    "teamOwnerText": "مالك المجموعة",
    "teamPowerText": "إدارة المجموعة",
    "teamSignPlaceholder": "الرجاء إدخال المحتوى",
    "teamSignText": "مقدمة المجموعة",
    "teamTitle": "اسم المجموعة",
    "teamTitleConfirmText": "لا يمكن أن يكون اسم المجموعة فارغًا",
    "teamTitlePlaceholder": "الرجاء إدخال اسم المجموعة",
    "teamTopModeText": "من يمكنه تثبيت رسالة؟",
    "textMsgText": "الرسائل النصية",
    "tipAIFailedMessageText": "فشل طلب نموذج اللغة الكبيرة",
    "tipAIMessageText": "تنسيق غير مدعوم",
    "tipMsgText": "رسالة سريعة",
    "topFailedText": "فشل في التثبيت",
    "topText": "لزج",
    "transferOwnerConfirmText": "تأكيد نقل مالك المجموعة",
    "transferOwnerText": "مالك مجموعة النقل",
    "transferTeamFailedText": "فشل نقل مالك المجموعة",
    "transferTeamSuccessText": "تم نقل مالك المجموعة بنجاح",
    "transferToText": "نقل إلى",
    "txmap": "خرائط تينسنت",
    "unTopText": "إزالة التثبيت",
    "unknow": "مجهول",
    "unknowMsgText": "رسالة غير معروفة",
    "unmuteAllTeamFailedText": "فشل في إنهاء الحظر",
    "unmuteAllTeamSuccessText": "تم بنجاح انهاء الحظر على جميع الأعضاء",
    "unmuteSessionText": "إلغاء عدم الإزعاج",
    "unreadText": "غير مقروء",
    "updateAliasFailedText": "فشل في تعديل التعليق",
    "updateAliasSuccessText": "تم تعديل الملاحظة بنجاح",
    "updateAllowAt": "تم تحديث &quot;أذونات @Everyone&quot; إلى",
    "updateAllowTop": "تم تحديث أذونات الرسائل اللاصقة إلى",
    "updateBitConfigMaskFailed": "فشل تحديث رسالة المجموعة &quot;عدم الإزعاج&quot;",
    "updateBitConfigMaskSuccess": "تم تحديث رسالة المجموعة &quot;لا تزعج&quot; بنجاح",
    "updateMyMemberNickFailed": "فشل في تحديث اسم مجموعتي",
    "updateMyMemberNickSuccess": "تم تحديث لقب مجموعتي بنجاح",
    "updateTeamAvatar": "تم تحديث الصورة الرمزية للمجموعة",
    "updateTeamFailedText": "فشل التعديل",
    "updateTeamIntro": "تم تحديث مقدمة المجموعة",
    "updateTeamInviteMode": "تم تحديث إذن المجموعة &quot;إذن دعوة الآخرين&quot; إلى",
    "updateTeamManagerFailText": "فشل تعديل مسؤول المجموعة",
    "updateTeamManagerSuccessText": "تم تعديل مسؤول المجموعة بنجاح",
    "updateTeamMute": "تم تحديث &quot;كتم صوت المجموعة&quot; إلى",
    "updateTeamName": "تحديث اسم المجموعة إلى",
    "updateTeamSuccessText": "تم التعديل بنجاح",
    "updateTeamUpdateTeamMode": "تم تحديث إذن المجموعة &quot;إذن تعديل بيانات المجموعة&quot; إلى",
    "uploadImgFailedText": "فشل تحميل الصورة",
    "uploadLimitText": "الحد الأقصى لحجم الصورة أو الفيديو أو الملف المدعوم",
    "uploadLimitUnit": "م",
    "userNotInTeam": "العضو لم يعد موجودا في المجموعة",
    "vedioCallText": "مكالمات الفيديو",
    "verifyMsgNotExitsText": "تمت معالجة رسالة التحقق",
    "videoMsgText": "رسالة فيديو",
    "videoText": "فيديو",
    "voiceCallText": "مكالمة صوتية",
    "voiceToText": "تحويل الكلام إلى نص",
    "voiceToTextFailedText": "فشل تحويل النص",
    "welcomeText": "مرحبا بكم في يونكسين",
    "woman": "أنثى",
    "yesText": "نعم",
    "you": "أنت",
    "zhText": "الصينية",
    zh: 'الصينية',
    en: 'الإنجليزية',
    jp: 'اليابانية',
    kor: 'الكورية',
    fra: 'الفرنسية',
    ara: 'Arabic',
    ru: 'اللغة الروسية',
    vie: 'الفيتنامية',
}
export default LocaleConfig
